import type { ReactNode } from "react";
import { createContext, useContext, useMemo } from "react";

export interface FeedbackConfig {
  accountToken: string;
  apiHost: string;
  reDisplayAfterDays: number;
  mfeRegistryBase: string;
  mfeVersion?: string;
}

const FeedbackContext = createContext<FeedbackConfig | null>(null);

export function useFeedbackConfig(): FeedbackConfig | null {
  return useContext(FeedbackContext);
}

interface FeedbackConfigProviderProps {
  accountToken?: string;
  apiHost?: string;
  reDisplayAfterDays?: number;
  mfeRegistryBase?: string;
  mfeVersion?: string;
  children: ReactNode;
}

export function FeedbackConfigProvider({
  accountToken,
  apiHost,
  reDisplayAfterDays,
  mfeRegistryBase,
  mfeVersion,
  children,
}: FeedbackConfigProviderProps): React.ReactElement {
  const value = useMemo<FeedbackConfig | null>(() => {
    if (!accountToken || !apiHost || !mfeRegistryBase) {
      return null;
    }
    return {
      accountToken,
      apiHost,
      reDisplayAfterDays: reDisplayAfterDays ?? 0,
      mfeRegistryBase,
      mfeVersion,
    };
  }, [accountToken, apiHost, reDisplayAfterDays, mfeRegistryBase, mfeVersion]);

  return (
    <FeedbackContext.Provider value={value}>
      {children}
    </FeedbackContext.Provider>
  );
}
